import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { isExpired } from "react-jwt";
import NotAuthorized from "./components/NotAuthorized";
import Header from "./components/Layout/Header";
import NavButtons from "./components/Layout/NavbarButtons";
import Footer from "./components/Layout/Footer";
import LoginPage from "./components/Login/LoginPage";
import ForgotPassword from "./components/Login/ForgotPassword";
import PasswordSetupPage from "./components/Login/PasswordSetupPage";
import DealerServicesDashboard from "./components/DealerAdmin/DealerServicesDashboard";
import "admin-lte/dist/css/adminlte.min.css";
import DealerServices from "./components/DealerAdmin/ManageDealerServices/DealerServices";
import "./assets/scss/styles.scss";
import CreateDealerShip from "./components/DealerAdmin/ManageDealerShip/CreateDealerShip";
import DealerShipListing from "./components/DealerAdmin/ManageDealerShip/DealerShipListing";
import { ToastContainer } from "react-toastify";
import ServiceDeskDashboard from "./components/ServiceDeskUser/ServiceDeskDashboard";
import Customer from "./components/Customer/Customer";
import PageNotFound from "./components/PageNotFound";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { AuthProvider } from "./context/AuthContext";
import PrintPDFPage from "./components/ServiceDeskUser/PrintPDFPage";
import CreateCustomerPage from "./components/ServiceDeskUser/CreateCustomerPage";
import ServiceOrderStepperForm from "./components/ServiceDeskUser/ServiceOrderStepperForm";
import "@fortawesome/fontawesome-free/css/all.min.css";
import SelectVehicle from "./components/ServiceDeskUser/SelectVehicle";
import CustomerHistory from "./components/Customer/CustomerHistory";
import ReportOrderListing from "./components/RepairOrder/RepairOrderListing";
import Loader from "./shared/Services/Loader/loader";
import ServiceDeskUsers from "./components/DealerAdmin/ManageServiceDeskUser/ServiceDeskUsers";
import CreateExternalUser from "./components/DealerAdmin/ManageServiceDeskUser/CreateExternalUser";
import { Protected } from "./auth/Protected";
const AppContent = () => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const isLoginPage =
    location.pathname === "/" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/set-password";
  const isPrintPDFPage = /^\/printpdf(\/.*)?$/.test(location.pathname);
  const { instance, inProgress } = useMsal();
  const accessToken = localStorage.getItem("accessToken");
  const isExternalUser = accessToken && !isExpired(accessToken);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
      }
    }
  }, [instance, inProgress]);

  return (
    <>
      {!isLoginPage && !isPrintPDFPage && (isAuthenticated || isExternalUser) && (
        <>
          <div className="top-header">
            <Header />
            <NavButtons />
          </div>
        </>
      )}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/reset-password"
          element={<PasswordSetupPage mode="reset" />}
        />
        <Route
          path="/set-password"
          element={<PasswordSetupPage mode="set" />}
        />

        <Route path="/not-authorized" element={<NotAuthorized />} />

        <Route
          path="/admin-dashboard"
          element={
            <Protected allowedRoles={["1"]}>
              <DealerServicesDashboard />
            </Protected>
          }
        />

        <Route
          path="/dealer-services"
          element={
            <Protected allowedRoles={["1"]}>
              <DealerServices />
            </Protected>
          }
        />

        <Route
          path="/services/dealership/list"
          element={
            <Protected allowedRoles={["1"]}>
              <DealerShipListing />
            </Protected>
          }
        />

        <Route
          path="/services/dealership/create"
          element={
            <Protected allowedRoles={["1"]}>
              <CreateDealerShip />
            </Protected>
          }
        />

        <Route
          path="/services/dealership/edit/:id"
          element={
            <Protected allowedRoles={["1"]}>
              <CreateDealerShip />
            </Protected>
          }
        />

        <Route
          path="/servicedeskusers"
          element={
            <Protected allowedRoles={["1"]}>
              <ServiceDeskUsers />
            </Protected>
          }
        />

        <Route
          path="/servicedeskusers/create"
          element={
            <Protected allowedRoles={["1"]}>
              <CreateExternalUser />
            </Protected>
          }
        />

        <Route
          path="/servicedeskusers/edit/:id"
          element={
            <Protected allowedRoles={["1"]}>
              <CreateExternalUser />
            </Protected>
          }
        />

        <Route
          path="/service-desk-dashboard"
          element={
            <Protected allowedRoles={["2"]}>
              <ServiceDeskDashboard />
            </Protected>
          }
        />

        <Route
          path="/service-desk-user/select-vehicle"
          element={
            <Protected allowedRoles={["2"]}>
              <SelectVehicle />
            </Protected>
          }
        />

        <Route
          path="/customer"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <Customer />
            </Protected>
          }
        />

        <Route
          path="/create-customer"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <CreateCustomerPage />
            </Protected>
          }
        />

        <Route
          path="/second-step"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <ServiceOrderStepperForm />
            </Protected>
          }
        />
        <Route
          path="/customer-list"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <Customer />
            </Protected>
          }
        />

        <Route
          path="/customer-history"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <CustomerHistory />
            </Protected>
          }
        />

        <Route
          path="/repair-orders"
          element={
            <Protected allowedRoles={["1", "2"]}>
              <ReportOrderListing />
            </Protected>
          }
        />

        <Route path="/printpdf/:tokenId" element={<PrintPDFPage />} />
        <Route path="/printHistory" element={<PrintPDFPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {(isAuthenticated || isExternalUser) && !isLoginPage && !isPrintPDFPage && <Footer />}
      <ToastContainer />
      <Loader />
    </>
  );
};

const App = () => {
  return <AppContent />;
};

export default App;
